(function () {
	'use strict';

	a3_cabin_reports.controller('EventFormModalCtrl', EventFormModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name EventFormModalCtrl
    * @description 
    * Flight Fervice Event Form Modal
    * @ngInject
    */
	function EventFormModalCtrl($scope, eventType, $uibModalInstance, FlightServiceEventsFactory) {
		
		$scope.eventType = { ...JSON.parse(JSON.stringify(eventType)) }
		var defaultStart = $scope.eventType.event.StartTime ? moment($scope.eventType.event.StartTime) : null;
		var defaultEnd = $scope.eventType.event.EndTime ?  moment($scope.eventType.event.EndTime) : null;
		$scope.cancel = cancel;
		$scope.close = close;
		$scope.submit = submit;
		$scope.startGetTime = startGetTime;
		$scope.endGetTime = endGetTime;
		$scope.resetStart = resetStart;
		$scope.resetEnd = resetEnd;
		$scope.clearRemarks = clearRemarks;
		$scope.requiredValueChanged = requiredValueChanged;
		$scope.showStart = defaultStart != null;
		$scope.showEnd = defaultEnd != null;
		$scope.showStartToggle = showStartToggle;
		$scope.showEndToggle = showEndToggle;
		$scope.showContent = 'eventForm';
		$scope.resultMessage = "";
		
		$scope.formValues = {};
		$scope.formValues.StartTime = $scope.eventType.event.StartTime ? moment($scope.eventType.event.StartTime) : null;
		$scope.formValues.EndTime = $scope.eventType.event.EndTime ?  moment($scope.eventType.event.EndTime) : null;
		$scope.formValues.notRequired = $scope.eventType.event.NotRequired;
		$scope.formValues.showTimePickers = !$scope.formValues.notRequired;

		function startGetTime() {
			$scope.formValues.StartTime = getNowValue();
		}
		function endGetTime() {
			$scope.formValues.EndTime = getNowValue();
		}

		function resetStart(){
			$scope.formValues.StartTime = defaultStart;
		}
		function resetEnd(){
			$scope.formValues.EndTime = defaultEnd;
		}

		function clearRemarks() {
			$scope.eventType.event.Remarks = '';
		}

		function showStartToggle(){
			$scope.showStart = !$scope.showStart;
			if( !$scope.showStart){
				resetStart();
			}
		}

		function showEndToggle(){
			$scope.showEnd = !$scope.showEnd;
			if( !$scope.showEnd){
				resetEnd();
			}else{
				$scope.showStart = true;
			}
		}

		function requiredValueChanged(){
			$scope.formValues.notRequired = !$scope.formValues.notRequired; 
			if($scope.formValues.notRequired){
				$scope.formValues.showTimePickers = false;
				$scope.formValues.StartTime = null;
				$scope.formValues.EndTime = null;
				clearRemarks();
			} else{
				$scope.formValues.showTimePickers = true;
			}
			
		}

		function getNowValue(){
			let currentUtcTime = new Date().toUTC();
			return moment.utc(currentUtcTime).format();
		}

		/**
         * Close the modal
         */
		function cancel() {
			var doRefreshPanel = true;
			$uibModalInstance.close(doRefreshPanel);
		}
		function close() {
			var doRefreshPanel = true;
			$uibModalInstance.close(doRefreshPanel);
		}

		/**
         * Submit event
         */
		function submit() {
			$scope.showContent = "loading";
			// UpdateTimes
			$scope.eventType.event.StartTime = ($scope.formValues.StartTime !== null && $scope.formValues.StartTime !== undefined) ? moment($scope.formValues.StartTime) : null;
			$scope.eventType.event.EndTime = ($scope.formValues.EndTime !== null && $scope.formValues.EndTime !== undefined) ? moment($scope.formValues.EndTime) : null;
			$scope.eventType.event.NotRequired = $scope.formValues.notRequired;

			FlightServiceEventsFactory.saveEvent($scope.eventType.event)
				.then(res => handleSaveResponse(res))
				.catch(res => SaveFailedCallBack(res));
		}

		/**
         * Response success
         */	
		function handleSaveResponse(results){
			if(results && results.data && results.data.success && results.data.data && results.data.data.length>0){
				FlightServiceEventsFactory.setEventsForFlightId($scope.eventType.event.FlightId, results.data.data);
				//Success
				$scope.resultMessage = "Success";
				$scope.showContent = 'results';
			}
			else{
				//Failed
				$scope.resultMessage = "Failed";
				$scope.showContent = 'results';

			}
		}

		/**
         * Response failed
         */	
		function SaveFailedCallBack(){
			$scope.resultMessage = "Failed";
			$scope.showContent = 'results';
		}
	}

})();